// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.app,
.content {
  height: 100%;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
}

body {
  background-color: #ffffff;
}

.app {
  display: flex;
  position: relative;
}

.content {
  flex: 1 1;
  /* margin-left dinamik olarak App.js'den ayarlanıyor */
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #e0e0e0;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Modern Sidebar Animations */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Smooth transitions for sidebar */
.ps-sidebar-container {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Menu item hover effects */
.ps-menu-button:hover {
  transform: translateX(4px);
  transition: all 0.3s ease;
}

/* Modern Scrollbar for sidebar */
.ps-sidebar-container::-webkit-scrollbar {
  width: 8px;
}

.ps-sidebar-container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
  margin: 8px 0;
}

.ps-sidebar-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(104, 112, 250, 0.6) 0%, rgba(104, 112, 250, 0.8) 100%);
  border-radius: 10px;
  border: 2px solid rgba(31, 42, 64, 0.5);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.ps-sidebar-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(104, 112, 250, 0.8) 0%, rgba(104, 112, 250, 1) 100%);
  box-shadow: 0 0 8px rgba(104, 112, 250, 0.6);
}

/* Custom date range takvimi grafiğin üstünde kalsın, tıklanabilsin (portal body'de render edilir) */
#stats-datepicker-portal {
  z-index: 9999 !important;
  position: relative;
}
#stats-datepicker-portal .react-datepicker-popper,
.stats-datepicker-popper-high-z {
  z-index: 9999 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,sDAAsD;AACxD;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,mCAAmC;AACnC;EACE,4DAA4D;AAC9D;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,+FAA+F;EAC/F,mBAAmB;EACnB,uCAAuC;EACvC,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,6FAA6F;EAC7F,4CAA4C;AAC9C;;AAEA,oGAAoG;AACpG;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap\");\n\nhtml,\nbody,\n#root,\n.app,\n.content {\n  height: 100%;\n  width: 100%;\n  font-family: \"Source Sans Pro\", sans-serif;\n}\n\nbody {\n  background-color: #ffffff;\n}\n\n.app {\n  display: flex;\n  position: relative;\n}\n\n.content {\n  flex: 1;\n  /* margin-left dinamik olarak App.js'den ayarlanıyor */\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #e0e0e0;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Modern Sidebar Animations */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes slideInFromLeft {\n  from {\n    transform: translateX(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Smooth transitions for sidebar */\n.ps-sidebar-container {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n/* Menu item hover effects */\n.ps-menu-button:hover {\n  transform: translateX(4px);\n  transition: all 0.3s ease;\n}\n\n/* Modern Scrollbar for sidebar */\n.ps-sidebar-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ps-sidebar-container::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 10px;\n  margin: 8px 0;\n}\n\n.ps-sidebar-container::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, rgba(104, 112, 250, 0.6) 0%, rgba(104, 112, 250, 0.8) 100%);\n  border-radius: 10px;\n  border: 2px solid rgba(31, 42, 64, 0.5);\n  transition: all 0.3s ease;\n}\n\n.ps-sidebar-container::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, rgba(104, 112, 250, 0.8) 0%, rgba(104, 112, 250, 1) 100%);\n  box-shadow: 0 0 8px rgba(104, 112, 250, 0.6);\n}\n\n/* Custom date range takvimi grafiğin üstünde kalsın, tıklanabilsin (portal body'de render edilir) */\n#stats-datepicker-portal {\n  z-index: 9999 !important;\n  position: relative;\n}\n#stats-datepicker-portal .react-datepicker-popper,\n.stats-datepicker-popper-high-z {\n  z-index: 9999 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
